import React from 'react';

export const MessageItem = ({ message, onImageClick }) => (
    <div className={`message ${message.sender === 'user' ? 'user' : ''}`}>
        {message.text && (
        <div className="message-bubble">
            {message.text}
        </div>
        )}
        {message.images?.length > 0 && (
        <div className="message-images">
            {message.images.map((image, index) => (
            <img
                key={index}
                src={image}
                alt={`Upload preview ${index + 1}`}
                className="message-image"
                onClick={() => onImageClick(image)}
            />
            ))}
        </div>
        )}
        {message.similarityText && (
        <div className="similarity-text">
            {message.similarityText}
        </div>
        )}

        {message.groupImages && (
        <div className="message-images">
            {message.groupImages.map((image, index) => (
            <img
                key={index}
                src={image.src}
                alt={`Result ${index + 1}`}
                className="message-image"
                onClick={() => onImageClick(image.src)}
            />
            ))}
        </div>
        )}
    </div>
);